"use client"

import React, {useEffect, useState} from 'react';
import Header2 from "@/app/(index)/header2";
import cx from "clsx";
import {Noto_Sans_TC, Rowdies} from 'next/font/google';
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import Footer from "@/app/(index)/footer";
import Bread from "@/app/(index)/bread";
import styles from '../../../index.module.css'
import {ActionIcon, Divider, Pagination, SimpleGrid, TextInput, Text} from "@mantine/core";
import {IconLayoutGridFilled, IconListDetails, IconSearch} from "@tabler/icons-react";
import {DatePickerInput, DatesProvider} from "@mantine/dates";
import '@mantine/dates/styles.css';
import "dayjs/locale/zh-tw";
import {useForm} from "@mantine/form";
import {IArticleQueryInputForm, IArticleQueryOutputForm} from "@/form/article";
import {indexArticleQuery} from "@/service";
import {useDebouncedValue, useMediaQuery} from "@mantine/hooks";
import ArticleList from "@/app/(index)/news/list/[id]/article-list";
import ArticleCard from "@/app/(index)/news/list/[id]/article-card";
import ArticleListSM from "@/app/(index)/news/list/[id]/article-list-sm";

const notoSansTC = Noto_Sans_TC({
    weight: ['400', '500', '700'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

const rowdies = Rowdies({
    weight: ['300', '400', '700'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

const newsName: {[key: string]: string} = {
    A: "焦點新聞",
    B: "活動訊息"
}

const newsNameE: {[key: string]: string} = {
    A: "News",
    B: "Events"
}

const Page = ({ params }: { params: { id: string } }) => {
    const { fontSize, lang } = useGlobalStateStore();
    const [outputResult, setOutputResult] = useState<IArticleQueryOutputForm | null>(null);
    const [viewType, setViewType] = useState<number>(1);
    const [value, setValue] = useState('');
    const [debounced] = useDebouncedValue(value, 500);
    const mediaQueryLessSM = useMediaQuery('(min-width: 480px)');

    const form = useForm<IArticleQueryInputForm>({
        mode: 'controlled',
        initialValues: {
            type: params.id,
            language: lang == "tw" ? "A" : "B",
            international: false,
            queryText: '',
            date: [null, null],
            rowsPerPage: 12,
            nowPage: 1
        }
    });

    useEffect(() => {
        form.setValues({
            nowPage: 1,
            rowsPerPage: form.getValues().rowsPerPage,
            queryText: debounced,
            language: lang == "tw" ? "A" : "B",
        });
        query();
    }, [form.getValues().rowsPerPage, form.getValues().date, debounced, lang]);


    const handleChangeNowPage = (n: number) => {
        form.setValues({ nowPage: n });
        query();
    }

    const query = () => {
        indexArticleQuery(form.getValues()).then(result => {
            setOutputResult(result);
        })
    }
    return (
        <DatesProvider settings={{ locale: 'zh-tw', firstDayOfWeek: 1, timezone: 'UTC'}}>
            <div className={cx("min-h-screen flex flex-col justify-between", notoSansTC.className)}>
                <div>
                    <Header2/>
                    {
                        mediaQueryLessSM && (
                            <Bread name_c={`中心動態 - ${newsName[params.id]}`}
                                   name_e={`What's New > ${newsNameE[params.id]}`}/>
                        )
                    }
                    {/*<div className="w-[1250px] mx-auto mb-[100px]">*/}
                    <div
                        className={cx("mx-auto mb-[100px]", mediaQueryLessSM ? 'w-[1250px]' : 'w-full mt-[100px] px-[10px]')}>
                        <div
                            className="bg-[url('/images/title_topBG.png')] bg-[length:100%_5px] bg-no-repeat bg-top inline-block pt-[15px] pb-[45px] text-[#5b5b5b] text-[35px] font-bold">
                            {lang == "tw" ? newsName[params.id] : newsNameE[params.id]}
                        </div>


                        <div className={cx("flex justify-between", !mediaQueryLessSM && 'flex-col')}>
                            <div className="flex gap-[20px] items-center">
                                <TextInput leftSection={<IconSearch/>}
                                           value={value}
                                           placeholder="請輸入查詢字串..."
                                           onChange={(event) => setValue(event.currentTarget.value)}
                                />

                                <div className="w-[300px]">
                                    <DatePickerInput
                                        type="range"
                                        placeholder="請選擇發佈日期起迄"
                                        valueFormat="YYYY年MM月DD日"
                                        clearable
                                        key={form.key('date')}
                                        {...form.getInputProps('date')}
                                    />
                                </div>
                            </div>

                            <div className="flex items-center gap-[20px]">
                                <div className="flex items-center">
                                    <div className="text-[#333333]">每頁顯示</div>
                                    <select className={styles.select}
                                            key={form.key('rowsPerPage')}
                                            {...form.getInputProps('rowsPerPage')}
                                    >
                                        <option value={12}>12</option>
                                        <option value={24}>24</option>
                                        <option value={48}>48</option>
                                    </select>
                                    <div className="text-[#333333]">筆</div>
                                </div>
                                <div>
                                    <ActionIcon variant="white" aria-label="Settings" size="xl"
                                                onClick={() => setViewType(0)}>
                                        <IconLayoutGridFilled size={36} stroke={1.5}
                                                              color={viewType == 0 ? "#1f5b61" : "#b6cfce"}/>
                                    </ActionIcon>

                                    <ActionIcon variant="white" aria-label="Settings" size="xl"
                                                onClick={() => setViewType(1)}>
                                        <IconListDetails size={36} stroke={2}
                                                         color={viewType == 1 ? "#1f5b61" : "#b6cfce"}/>
                                    </ActionIcon>
                                </div>
                            </div>
                        </div>

                        <Divider color="#cedbdc" my={30}/>

                        {/*{*/}
                        {/*    viewType == 1 && (*/}
                        {/*        <div className="flex flex-col gap-3">*/}
                        {/*            {*/}
                        {/*                outputResult?.obj?.map((item, index) => (*/}
                        {/*                    */}
                        {/*                    <ArticleList item={item} key={`listview-${index}`}/>*/}
                        {/*                ))*/}
                        {/*            }*/}
                        {/*        </div>*/}
                        {/*    )*/}
                        {/*}*/}

                        {
                            viewType == 1 && (
                                <div className="flex flex-col gap-3">
                                    {
                                        outputResult?.obj?.map((item, index) =>
                                            mediaQueryLessSM ? (
                                                <ArticleList item={item} key={`listview-${index}`}/>
                                            ) : (
                                                <ArticleListSM item={item} key={`listview-sm-${index}`}/>
                                            )
                                        )
                                    }
                                </div>
                            )
                        }
                        {
                            viewType == 0 && (
                                <SimpleGrid cols={mediaQueryLessSM ? 3 : 1} spacing={40}>
                                    {
                                        outputResult?.obj?.map((item, index) => (
                                            <ArticleCard item={item} key={`cardview-${index}`}/>
                                        ))
                                    }
                                </SimpleGrid>
                            )
                        }

                        {
                            outputResult?.totalRows == 0 && (
                                <div className="text-3xl font-bold">查無資料，請重新查詢</div>
                            )
                        }

                        {
                            (outputResult?.totalPages ?? 0) > 1 && (
                                <div className="mt-10 flex justify-end">
                                    <Pagination total={outputResult?.totalPages!!}
                                                value={outputResult?.nowPage}
                                                radius={"xl"}
                                                color="#316d68"
                                                siblings={2}
                                                className={cx(rowdies.className, "font-light")}
                                                onChange={handleChangeNowPage} mt="sm"/>
                                </div>
                            )
                        }

                    </div>
                </div>
                <Footer/>
            </div>
        </DatesProvider>
    );
}
export default Page
